export const organizationSchema = {
  "script:ld+json": {
    "@context": "https://schema.org",
    "@type": "Organization",
    url: "https://updrinks.de/",
    logo: "https://updrinks.de/logo.svg",
    name: "UPdrinks",
    legalName: "UPdrinks GmbH",
    alternateName: "Voll",
    vatID: "DE365595940",
    founder: [
      {
        "@type": "Person",
        name: "Henri Olbrich",
      },
      {
        "@type": "Person",
        name: "Benjamin Vettel",
      },
    ],
    address: {
      "@type": "PostalAddress",
      postalCode: "64625",
      streetAddress: "Lilienthalstraße 51",
      addressCountry: "DE",
    },
  },
};

export const noIndexNoFollow = {
  name: "robots",
  content: `noindex, nofollow`,
};

export const indexFollow = {
  name: "robots",
  content: "index, follow",
};
